import { render, staticRenderFns } from "./file_preview.vue?vue&type=template&id=55a6e442&"
import script from "./file_preview.vue?vue&type=script&lang=js&"
export * from "./file_preview.vue?vue&type=script&lang=js&"
import style0 from "./file_preview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports